import { useEffect } from "react"

import { REQUEST_METHOD, useForm } from '@laramie/ui';
import { InputCustom, Modal } from "../../common"
import { useManagedContext } from "../../hooks"
import { APIS } from "../../../config/apis"
import { standardRequest } from "../../../utils/requests"


const TEXTOS = [
    { campo: "textoCabecera", configuracion: "TituloEjecutivoTextoCabecera" },
    { campo: "textoFirma1", configuracion: "TituloEjecutivoTextoFirma1" },
    { campo: "textoFirma2", configuracion: "TituloEjecutivoTextoFirma2" },
    { campo: "textoFirma3", configuracion: "TituloEjecutivoTextoFirma3" },
    { campo: "textoFirma4", configuracion: "TituloEjecutivoTextoFirma4" },
]

const TituloEjecutivoTextosModal = ({ onConfirm, onDismiss }) => {
    const { setIsLoading } = useManagedContext()

    const [formValues, formHandle, , formSet] = useForm({
        textoCabecera: '',
        textoFirma1: '',
        textoFirma2: '',
        textoFirma3: '',
        textoFirma4: ''
    })

    useEffect(() => {
        setIsLoading(true)

        Promise.all(TEXTOS.map(({ configuracion }) =>
            standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.CONFIGURACION}/${configuracion}`, null, { disableToast: true })
            .then(({ valor }) => valor ? standardRequest(REQUEST_METHOD.GET, `${APIS.URLS.VARIABLE}/${valor}/global`, null, { disableToast: true }) : null)
            .then(variableGlobal => variableGlobal?.valor ?? '')
            .catch(() => '')
        ))
        .then(valores => formSet(TEXTOS.reduce((values, { campo }, index) => ({ ...values, [campo]: valores[index] }), {})))
        .finally(() => setIsLoading(false))
    }, [])

    return (
        <Modal
            show
            size="lg"
            title="Textos del título ejecutivo"
            onEscape={onDismiss}
            body={(
                <div className='row form-basic'>
                    <div className="mb-3 col-12">
                        <label htmlFor="textoCabecera" className="form-label">Texto de cabecera</label>
                        <textarea
                            name="textoCabecera"
                            placeholder=""
                            className="form-control"
                            value={formValues.textoCabecera}
                            onChange={formHandle}
                            rows="6"
							maxLength={500}
                            style={{ resize: 'none' }}
                        />
                    </div>

                    {[1, 2, 3, 4].map(numero => (
                        <div className="mb-3 col-12 col-md-6" key={numero}>
                            <label htmlFor={`textoFirma${numero}`} className="form-label">{`Aclaración firma ${numero}`}</label>
                            <InputCustom
                                name={`textoFirma${numero}`}
                                type="string"
                                placeholder=""
                                className="form-control"
                                value={formValues[`textoFirma${numero}`]}
                                onChange={formHandle}
                                maxLength={500}
                            />
                        </div>
                    ))}
                </div>
            )}
            footer={(<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onDismiss}>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={() => onConfirm(formValues)}>Generar</button>
            </>)}
        />
    )
}

export default TituloEjecutivoTextosModal
